import React, { useEffect, useRef } from "react";
import Lottie from "react-lottie";
import confetti from "canvas-confetti";

import checkoutSuccessAnimation from "@/assets/img/Checkout/Success/checkout-success.json";

const CheckoutSuccessAnimation = () => {
	const rootRef = useRef();
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: checkoutSuccessAnimation,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};

	useEffect(() => {
		if (!rootRef.current) return;

		// calculate the origin based on the center of image
		// image might be offset
		const boundingBox = rootRef.current.getBoundingClientRect();
		const origin = {
			x: (boundingBox.left + boundingBox.width / 2) / window.innerWidth,
			y: (boundingBox.top + boundingBox.height / 2) / window.innerHeight + 0.1,
		};

		confetti({
			particleCount: 100,
			spread: 70,
			origin: origin,
		});
	}, []);

	return <Lottie options={defaultOptions} height={200} width={200} />;
};
export default CheckoutSuccessAnimation;
